/* eslint-disable import/prefer-default-export */
import { hasVariant } from '../../selectors/configSelectors';
import { MVT_1172, WEB_FUNNEL_HOLDOUT } from '../../flags/experiments';
import { errorForConfig } from '../errors';

export const statusForState = ({ config }) => {
  const error = errorForConfig(config);
  return {
    status: error ? 500 : 200,
    error,
  };
};

export const isCondensedMobileLayoutActive = (state) =>
  !hasVariant(state, 'holdout', WEB_FUNNEL_HOLDOUT) && hasVariant(state, MVT_1172, 'on');
